import React, {useEffect, useState } from 'react';
import { IAddModalState } from "../type/my-notes-page.types";
import Modal from "antd/lib/modal/Modal";
import { Form, Input } from "antd";
import notes from "../../../resources/notes";
import AddTags from "../../common/tags/add-tags";
import { DatePicker, Select } from "antd/lib";
import { createNote, editNote, mapFormValuesToPayload, mapNoteToFormValue } from
        "../action/my-notes-page.actions";
import { Priority } from "../../../domains/models/note";
import dayjs from 'dayjs';
import Locale from "../../../core/locale/locale";
import TiptapEditor from "../../common/tiptap-editor/tiptap-editor";
import "../../../styles/component/add-note-modal.scss"



const AddNoteModal: React.FC<IAddModalState> = (props) => {
    const resource = notes.addNoteModal;
    const [myForm] = Form.useForm();

    const colors = ['nc-yellow', 'nc-blue', 'nc-purple', 'nc-green', 'nc-pink', 'nc-orange'];

    const [color, setColor] = useState<string>();


    useEffect(() => {
        if (!props.modalState.open) {
            return;
        }

        if (props.modalState.noteData) {
            const initialFormValues = mapNoteToFormValue(
                props.modalState.noteData
            );

            setColor(initialFormValues.colorKey || '');
            myForm.setFieldsValue(initialFormValues);
        } else {
            myForm.resetFields();
            setColor('');
        }
    }, [
        props.modalState.open,
        props.modalState.noteData,
        myForm
    ]);

    async function handleSubmit() {
        try {
            const formData = await myForm.validateFields();

            formData.id = props.modalState.noteData?.id;
            formData.colorKey = color;

            const payload = mapFormValuesToPayload(formData);
            if (props.modalState.mode == 'add') {
                const res = await createNote(payload);
                const noteId = res.split('/').pop();
                formData.id = noteId;
                formData.auditInfo = {
                    createdOn: dayjs().format(Locale.dateFormat),
                    createdBy: ''
                };
            }else if (props.modalState.noteData && props.modalState.mode == 'edit') {
                await editNote(props.modalState.noteData.id, payload);
            }
            props.upsertNotes(formData);
            myForm.resetFields();
            props.closeAddNoteModal();
        } catch (error) {
            // validation failed
        }
    }

    // async function handleSubmit() {
    //     const formData = myForm.getFieldsValue();
    //     formData.id = props.modalState.noteData?.id;
    //     formData.colorKey = color;
    //     const payload = mapFormValuesToPayload(formData);
    //     if (props.modalState.mode == 'add') {
    //         const res = await createNote(payload);
    //         const noteId = res.split('/').pop();
    //         formData.id = noteId;
    //         formData.auditInfo = {
    //             createdOn: dayjs().format(Locale.dateFormat),
    //             createdBy: ''
    //         };
    //     }
    //     if (props.modalState.noteData && props.modalState.mode == 'edit') {
    //         await editNote(props.modalState.noteData.id, payload);
    //     }
    //     props.upsertNotes(formData);
    //     myForm.resetFields();
    //     props.closeAddNoteModal();
    // }

    function handleCancel() {
        myForm.resetFields();
        props.closeAddNoteModal();
    }

    function handleColorKeyChange(key: string) {
        if (key === color) {
            setColor('')
        } else {
            setColor(key)
        }
    }

    const options = [
        {
            label: 'None',
            value: null
        },
        ...Object.entries(Priority).map(([key, value]) => ({
            label: value,
            value: key,
        })),
    ]

    const modalTitle = (props.modalState.mode === 'add' ? resource.title : resource.editTitle);

    return (
        <Modal
            className={`hrms-app add-note-modal ${color}`}
            open={props.modalState.open}
            onCancel={handleCancel}
            onOk={handleSubmit}
            title={modalTitle}
            okText={resource.okButtonLabel}
        >
            <Form
                className={'add-note-modal__form'}
                layout="vertical"
                form={myForm}
            >
                <Form.Item
                    name={'title'}
                    className={'note-title'}
                    label={resource.inputTitleLabel}
                >
                    <Input placeholder={resource.titleInputPlaceholder}/>
                </Form.Item>
                <Form.Item
                    name={'content'}
                    className={'note-content'}
                    label={resource.inputContentLabel}
                >
                    <TiptapEditor/>

                </Form.Item>
                <div className={'deadline-priority-section'}>
                    <Form.Item
                        name={'priority'}
                        className={'note-select'}
                        label={resource.priorityTitleLabel}
                    >
                        <Select
                            options={options}
                        />
                    </Form.Item>

                    <Form.Item
                        name={'dueDate'}
                        className={'note-datepicker'}
                        label={resource.deadlineTitleLabel}
                    >
                        <DatePicker  format={Locale.displayDate}/>
                    </Form.Item>
                </div>
                <div className={'color-tags-section'}>
                    <Form.Item
                        name={'colorKey'}
                        className={'note-color'}
                        label={resource.colorInputLabel}
                    >
                        <div className={'color-select-wrapper'}>
                            {colors.map((key) => (
                                <span
                                    className={`color-item ${key} ${color === key ? 'active' : ''}`}
                                    key={key}
                                    onClick={() => handleColorKeyChange(key)}
                                />
                            ))}
                        </div>
                    </Form.Item>

                    <Form.Item
                        name={'tag'}
                        className={'note-tags'}
                        label={resource.tagInputLabel}

                    >
                        <AddTags tagLabel={'Add Tags'}/>
                    </Form.Item>
                </div>
            </Form>

        </Modal>
    )
}

export default AddNoteModal;
